import "./style/popup.scss"

import React, { useId } from "react"

// Components
import { StaticBox } from "@modules/shared/Grid"
import Modal from "@ng-mw/reol/components/Modal"
import PopupButtons from "./PopupButtons"
import PopupHeader from "./PopupHeader"
import PopupScrollView from "./PopupScrollView"
import PopupTitle from "./PopupTitle"
import { PopupAnimationEnum } from "./PopupTransitions"

export const Background = {
    White: "white",
    Red: "red",
    LightRed: "light-red",
} as const

export type BackgroundEnum = (typeof Background)[keyof typeof Background]

interface PopupProps {
    buttons?: React.ReactNode | React.JSX.Element
    children?: React.ReactNode
    className?: string
    isForcedFullscreen?: boolean
    isFullscreenPopup?: boolean
    isHeaderActionsOverflow?: boolean
    isOpen: boolean
    isSimple?: boolean
    isSwipeToCloseDisabled?: boolean
    isTitleHidden?: boolean
    onClose?: () => void
    onEnter?: () => void
    onEntered?: () => void
    onEntering?: () => void
    onExit?: () => void
    onExited?: () => void
    onExiting?: () => void

    onGoBack?: () => void
    title?: string | React.ReactNode
    titleIllustration?: React.ReactNode
    wrapperClassName?: string
    popupAnimation?: PopupAnimationEnum
    backgroundColor?: BackgroundEnum
    hideCloseButton?: boolean
}

const Popup = ({
    buttons,
    children,
    className,
    isForcedFullscreen,
    isFullscreenPopup,
    isHeaderActionsOverflow,
    isOpen,
    isSimple,
    isSwipeToCloseDisabled,
    isTitleHidden,
    onClose,
    onEnter,
    onEntered,
    onEntering,
    onExit,
    onExited,
    onExiting,
    onGoBack,
    title,
    titleIllustration,
    wrapperClassName,
    popupAnimation,
    backgroundColor,
    hideCloseButton,
}: PopupProps) => {
    const id = useId()

    return (
        <Modal
            id={id}
            // backgroundColor={backgroundColor}
            // className={className}
            // isForcedFullscreen={isForcedFullscreen}
            isVisible={isOpen}
            shouldCloseOnOverlayClick={!isSwipeToCloseDisabled}
            onClose={onClose}
            showCloseButton={false}
            name={backgroundColor ? `popup-${backgroundColor}` : "popup"}
            fullBleedBanner={
                <>
                    <PopupHeader
                        ariaControls={id}
                        isActionsOverflow={isHeaderActionsOverflow}
                        onClose={onClose}
                        onGoBack={onGoBack}
                        title={title}
                        hideCloseButton={hideCloseButton}
                    />

                    <PopupScrollView>
                        {title ? (
                            <PopupTitle
                                id={id}
                                illustration={titleIllustration}
                                isHidden={isTitleHidden}
                                isSimple={isSimple}
                            >
                                {title}
                            </PopupTitle>
                        ) : null}
                        {children}
                    </PopupScrollView>

                    {buttons ? (
                        <StaticBox className="">
                            <PopupButtons>{buttons}</PopupButtons>
                        </StaticBox>
                    ) : null}
                </>
            }
            // onEnter={onEnter}
            // onEntered={onEntered}
            // onEntering={onEntering}
            // onExit={onExit}
            // onExited={onExited}
            // onExiting={onExiting}
            // popupAnimation={popupAnimation}
            // wrapperClassName={wrapperClassName}
            // isFullscreenPopup={isFullscreenPopup}
            size="large"
        />
    )
}

export { default as PopupButtons } from "./PopupButtons"
export { default as PopupContent } from "./PopupContent"
export { default as PopupScrollView } from "./PopupScrollView"
export { default as PopupText } from "./PopupText"
export { default as PopupTitle } from "./PopupTitle"
export { default as PopupTransitions } from "./PopupTransitions"

export default Popup
